var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: "100%",
    height: "100%",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "twitterLogo"
  }, "Go to the Endless Ways twitter account.") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "twitterLogo"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6,0,0,0.6,-859.658,-1704.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1463.03,2841.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30.27,-30.27C-46.989,-30.27 -60.542,-16.719 -60.542,0.001C-60.542,16.719 -46.989,30.27 -30.27,30.27C-13.552,30.27 0.001,16.719 0.001,0.001C0.001,-16.719 -13.552,-30.27 -30.27,-30.27",
    style: {
      fill: "rgb(179,179,179)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1480.02,2880.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-17.231C0.026,-16.861 0.026,-16.477 0.026,-16.107C0.026,-4.641 -8.702,8.57 -24.651,8.57C-29.57,8.57 -34.133,7.142 -37.968,4.682C-37.267,4.761 -36.592,4.788 -35.878,4.788C-31.818,4.788 -28.089,3.413 -25.113,1.085C-28.922,1.006 -32.122,-1.494 -33.22,-4.932C-31.884,-4.734 -30.681,-4.734 -29.306,-5.091C-33.273,-5.898 -36.249,-9.389 -36.249,-13.607L-36.249,-13.713C-35.098,-13.065 -33.749,-12.669 -32.334,-12.616C-34.75,-14.223 -36.2,-16.934 -36.196,-19.836C-36.196,-21.45 -35.772,-22.931 -35.019,-24.214C-30.747,-18.95 -24.333,-15.512 -17.139,-15.142C-18.369,-21.026 -13.965,-25.801 -8.675,-25.801C-6.176,-25.801 -3.928,-24.756 -2.341,-23.063C-0.384,-23.433 1.494,-24.161 3.161,-25.152C2.513,-23.142 1.151,-21.45 -0.648,-20.378C1.098,-20.564 2.79,-21.053 4.351,-21.727C3.174,-19.995 1.693,-18.461 0,-17.231",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitterLogo.4ec1bf4d.svg";
export { ForwardRef as ReactComponent };